<template>
    <form class="edit-profile" v-bind:action="apiUrl + '/users/' + this.user.id" v-on:submit.prevent="handleSubmit">
        <div class="edit-profile__col">
            <div class="edit-profile__edit-photo">
                <div class="edit-profile__edit-photo__photo-container">
                    <div class="edit-profile__edit-photo__photo-preview"
                         v-bind:class="{ 'is-loaded' : imageObj.isLoaded }"
                         v-bind:style="imageStyleProperty"
                         v-on:mousedown="handleImageDragStart"
                         v-on:mousemove="handleImageDrag"
                         v-on:mouseup="handleImageDragEnd">
                        <img class="edit-profile__edit-photo__placeholder" src="/img/user-picture.png" v-bind:alt="name" v-if="!imageObj.src" />
                        <img class="edit-profile__edit-photo__photo" v-bind:src="imageObj.src" v-if="imageObj.src" />
                    </div>
                </div>
                <div v-if="imageObj.src">
                    <input class="edit-tile__scale-image-control" type="range" step="0.01"
                           v-bind:min="imageObj.scaleMin"
                           v-bind:max="imageObj.scaleMax"
                           v-if="showScaleImageControl"
                           v-model.number="imageObj.scale"
                           v-on:input="handleImageScale"
                    />
                </div>
                <a class="edit-profile__center-image-btn" v-on:click="centerImage" v-if="showScaleImageControl">{{ __('Center image') }}</a>
                <input class="edit-profile__image-control" type="file" accept="image/*" v-on:change="handleImageUpload" />
                <div>
                    <a class="edit-profile__edit-photo__link" v-on:click="showImageUploadDialog">{{ __('Upload photo') }}</a> <span v-if="imageObj.src">|</span>
                    <a class="is-danger edit-profile__remove-image-btn" v-if="imageObj.src" v-on:click="removeImage">{{ __('Remove photo') }}</a>

                </div>
            </div>
            <router-link class="edit-profile__change-password-link"
                         v-bind:to="{ name: 'profile.password' }"
            >
                {{ __('Change password') }}
            </router-link>
        </div>
        <div class="edit-profile__col">
            <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.name }">
                <label class="form__label" for="name">{{ __('Your name') }}</label>
                <span class="jam jam-user-circle is-large"></span>
                <input class="form__control is-large" id="name" type="text" autocomplete="off"
                       v-bind:placeholder="__('Enter name')"
                       v-model="name"
                />
                <span class="form__focus"></span>
            </div>
            <small class="form__error" v-if="errors.name">{{ errors.name[0] }}</small>

            <div class="form__group has-icon" v-bind:class="{ 'has-error' : errors.email }">
                <label class="form__label" for="email">{{ __('Your email') }}</label>
                <span class="jam jam-newsletter is-large"></span>
                <input class="form__control is-large" id="email" type="email" autocomplete="off"
                       v-bind:placeholder="__('Enter email')"
                       v-model="email"
                />
                <span class="form__focus"></span>
            </div>
            <small class="form__error" v-if="errors.email">{{ errors.email[0] }}</small>

            <button class="btn is-primary edit-profile__save-btn">{{ __('Save') }}</button>
        </div>
    </form>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    export default {
        computed: {
            imageStyleProperty: function () {
                let prop = '';

                let height = this.imageObj.height;
                let width = this.imageObj.width;
                let scale = this.imageObj.scale;

                if (this.imageObj.height != 0 && this.imageObj.width != 0) {
                    if (this.imageObj.initialHeight && this.imageObj.initialWidth) {
                        prop += 'height: ' + (height * scale) + 'px; ';
                        prop += 'width: ' + (width * scale) + 'px; ';
                    }

                    prop += 'transform: translate(' + this.imageObj.currentX + 'px, ' + this.imageObj.currentY + 'px);';
                } else {
                    prop = 'transform: translate(0px, 0px);';
                }

                return prop.trim();
            }
        },
        created: function () {
            this.init();
        },
        data: function () {
            return {
                email: '',
                errors: {},
                imageObj: {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialHeight: 0,
                    initialWidth: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    scaleMin: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                },
                imgHeight: 200,
                imgWidth: 200,
                name: '',
                showScaleImageControl: false

            }
        },
        methods: {
            centerImage: function () {
                this.imageObj.currentX = Math.floor((200 - this.imageObj.width * this.imageObj.scale) / 2);
                this.imageObj.currentY = Math.floor((200 - this.imageObj.height * this.imageObj.scale) / 2);

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
            },
            handleImageDrag: function (e) {
                if (this.imageObj.isMoving) {
                    e.preventDefault();

                    if (e.type === "touchmove") {
                        this.imageObj.currentX = e.touches[0].clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.touches[0].clientY - this.imageObj.initialY;
                    } else {
                        this.imageObj.currentX = e.clientX - this.imageObj.initialX;
                        this.imageObj.currentY = e.clientY - this.imageObj.initialY;
                    }

                    if (this.imageObj.width * this.imageObj.scale >= this.imgWidth) {
                        if (this.imageObj.currentX < 0 && this.imageObj.currentX < -1 * this.imageObj.width * this.imageObj.scale + this.imgWidth) {
                            this.imageObj.currentX = -1 * this.imageObj.width * this.imageObj.scale + this.imgWidth;
                        } else if (this.imageObj.currentX > 0) {
                            this.imageObj.currentX = 0;
                        }
                    } else {
                        if (this.imageObj.currentX > 0 && this.imageObj.currentX > this.imgWidth - this.imageObj.width * this.imageObj.scale) {
                            this.imageObj.currentX = this.imgWidth - this.imageObj.width * this.imageObj.scale;
                        } else if (this.imageObj.currentX < 0) {
                            this.imageObj.currentX = 0;
                        }

                    }

                    if (this.imageObj.height * this.imageObj.scale >= this.imgHeight) {
                        if (this.imageObj.currentY < 0 && this.imageObj.currentY < -1 * this.imageObj.height * this.imageObj.scale + this.imgHeight) {
                            this.imageObj.currentY = -1 * this.imageObj.height * this.imageObj.scale + this.imgHeight;
                        } else if (this.imageObj.currentY > 0) {
                            this.imageObj.currentY = 0;
                        }
                    } else {
                        if (this.imageObj.currentY > 0 && this.imageObj.currentY > this.imgHeight - this.imageObj.height * this.imageObj.scale) {
                            this.imageObj.currentY = this.imgHeight - this.imageObj.height * this.imageObj.scale;
                        } else if (this.imageObj.currentY < 0) {
                            this.imageObj.currentY = 0;
                        }

                    }

                    this.imageObj.offsetX = this.imageObj.currentX;
                    this.imageObj.offsetY = this.imageObj.currentY;
                }
            },
            handleImageDragEnd: function (e) {
                e.preventDefault();

                this.imageObj.initialX = this.imageObj.currentX;
                this.imageObj.initialY = this.imageObj.currentY;

                this.imageObj.isMoving = false;
            },
            handleImageDragStart: function (e) {
                e.preventDefault();

                if (e.type === "touchstart") {
                    this.imageObj.initialX = e.touches[0].clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.touches[0].clientY - this.imageObj.offsetY;
                } else {
                    this.imageObj.initialX = e.clientX - this.imageObj.offsetX;
                    this.imageObj.initialY = e.clientY - this.imageObj.offsetY;
                }

                if (e.target === document.querySelector('.edit-profile__edit-photo__photo-preview')) {
                    this.imageObj.isMoving = true;
                }
            },
            handleImageScale: function () {
                this.imageObj.currentX = 0;
                this.imageObj.currentY = 0;

                this.imageObj.offsetX = this.imageObj.currentX;
                this.imageObj.offsetY = this.imageObj.currentY;
            },
            handleImageUpload: function () {
                const file = document.querySelector('.edit-profile__image-control').files[0];
                const img = new Image();
                const reader = new FileReader();

                reader.readAsDataURL(file);
                reader.onload = function () {
                    this.imageObj.src = reader.result;
                    this.imageObj.scale = 1;
                    img.src = reader.result;

                }.bind(this);

                img.onload = function () {

                    const imgEl = document.querySelector('.edit-profile__edit-photo__photo');

                    this.imageObj.initialHeight = imgEl.offsetHeight;
                    this.imageObj.initialWidth = imgEl.offsetWidth;

                    this.imageObj.isLoaded = true;

                    this.imageObj.height = Math.floor(this.imageObj.initialHeight * this.imageObj.scale);
                    this.imageObj.width = Math.floor(this.imageObj.initialWidth * this.imageObj.scale);

                    let scale = 1;
                    if (this.imgWidth > this.imageObj.width) {
                        scale = this.imgWidth / this.imageObj.width;
                    }
                    if (this.imgHeight > this.imageObj.height) {
                        scale = this.imgHeight / this.imageObj.height;
                    }
                    this.imageObj.height = this.imageObj.height * scale;
                    this.imageObj.width = this.imageObj.width * scale;

                    this.showScaleImageControl = true;

                    if (this.imageObj.width < img.width) {
                        this.imageObj.scaleMin = 0.1;
                        this.imageObj.scaleMax = Math.floor(img.width / this.imageObj.width);
                    } else {
                        this.imageObj.scaleMin = Math.floor(this.imageObj.width / img.width);
                        this.imageObj.scaleMax = 0.1;
                    }
                }.bind(this);
            },
            handleSubmit: function (e) {
                eventBus.$emit('show-loader');

                const form = e.target;
                const action = form.getAttribute('action');

                const data = {
                    name: this.name
                };
                if (this.email != this.user.email) {
                    data.email = this.email;
                }

                data.image = this.imageObj;


                this.$http.patch(action, data).then(function (response) {
                    this.updateUser(response.body);

                    eventBus.$emit('show-alert', 'success', this.__('Your profile has been updated successfully.'));
                    eventBus.$emit('hide-loader');
                }, function (response) {
                    if (response.status == 422 && response.body.errors) {
                        this.errors = response.body.errors;
                    }

                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There were some errors validation the form. Please review and correct them.')
                    );
                    eventBus.$emit('hide-loader');
                });
            },
            init: function () {
                eventBus.$emit('show-loader');

                this.email = this.user.email;
                this.name = this.user.name;
                if (this.user.image) {
                    this.imageObj.src = '/media/users/' + this.user.image;
                }

                eventBus.$emit('hide-loader');
            },
            removeImage: function () {
                this.imageObj = {
                    currentX: 0,
                    currentY: 0,
                    height: 0,
                    initialX: 0,
                    initialY: 0,
                    isLoaded: false,
                    isMoving: false,
                    offsetX: 0,
                    offsetY: 0,
                    scale: 1,
                    tile__name: 1,
                    scaleMax: 1,
                    src: null,
                    width: 0
                };

                this.showScaleImageControl = false;
            },
            showImageUploadDialog: function () {
                document.querySelector('.edit-profile__image-control').click();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/EditProfile.vue